import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { trackEvent } from "@/analytics";
import PageHero from "@/components/tex/PageHero";

function FaqItem({ item, index }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className={"faq-item" + (open ? " open" : "")} data-testid={`faq-${index}`}>
      <button
        className="faq-q"
        onClick={() => {
          const next = !open;
          setOpen(next);
          if (next) trackEvent("faq_opened", { question: item.q });
        }}
        aria-expanded={open}
      >
        <span>{item.q}</span>
        <span className="faq-chevron">{open ? "–" : "+"}</span>
      </button>
      {open && <div className="faq-a">{item.a}</div>}
    </div>
  );
}

export default function FaqPage() {
  const [faqs, setFaqs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "FAQ — Texcheme";
    window.scrollTo(0, 0);
    api
      .getFaqs()
      .then(setFaqs)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Questions we hear often"
        lead="Grades, minimums, pricing, paperwork and delivery — the practical things buyers ask before a first order."
      />

      <section className="panel" data-testid="faq-list">
        <div className="wrap faq-wrap">
          {error && <p className="note">Couldn&apos;t load FAQs right now. {error}</p>}
          {faqs.map((item, i) => (
            <FaqItem key={i} item={item} index={i} />
          ))}
        </div>
      </section>

      <section className="panel dark cta-panel" data-testid="faq-cta">
        <div className="wrap cta-panel-inner">
          <div>
            <h2>Didn&apos;t find your answer?</h2>
            <p>Ask us directly — we usually reply the same working day.</p>
          </div>
          <Link to="/contact" className="btn btn-brand">Contact us</Link>
        </div>
      </section>
    </>
  );
}
